<template>
  <OnClickOutside @trigger="hideLikePicker">
    <span ref="likeButton" data-cy="like-comment-button" class="like-link" @click="toggleLikePicker">
      <span v-if="likeType">{{ likeIcon }}</span>
      <img v-else class="like-icon" src="@/assets/LikeIcon.svg" />
      &nbsp;<span :style="likeStyle">{{ $t(likeText) }}</span>
    </span>
  </OnClickOutside>
</template>

<script>

import LikeService from '../../service/like.service'
import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import LikePicker from './LikePicker'
import { OnClickOutside } from '@vueuse/components'

let commentsContainer = null

export default {
  name: 'LikeCommentButton',
  components: { OnClickOutside },
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      picker: null,
      popup: null
    }
  },
  mounted() {
    commentsContainer = this.$refs.likeButton.closest('.comments-container')

    this.picker = new VueRenderer(LikePicker, {
      parent: this
    })
    this.picker.ref.$on('select', this.onLike)
    this.popup = tippy('body', {
      appendTo: () => commentsContainer,
      content: this.picker.element,
      showOnCreate: false,
      interactive: true,
      trigger: 'manual',
      placement: 'top-start',
      zIndex: 1,
      hideOnClick: false
    })[0]
  },
  computed: {
    likeType() {
      return this.comment.userLike ? this.comment.userLike.type : undefined
    },
    likeIcon() {
      return LikeService.getLikeIcon(this.likeType || 'like')
    },
    likeText() {
      return LikeService.getLikeText(this.likeType || 'like')
    },
    likeStyle() {
      return LikeService.getLikeStyle(this.likeType)
    }
  },
  methods: {
    onLike(type) {
      this.popup.hide()
      return this.likeType === type ? this.unlike(type) : this.like(type)
    },
    async like(type) {
      await this.$store.dispatch('likeComment', { comment: this.comment, type })
    },
    async unlike(type) {
      await this.$store.dispatch('unlikeComment', { comment: this.comment, type })
    },
    toggleLikePicker(event) {
      if (!this.popup.state.isVisible) {
        this.popup.show()
        commentsContainer.addEventListener('scroll', this.hideLikePicker)
      } else {
        commentsContainer.removeEventListener('scroll', this.hideLikePicker)
        this.popup.hide()
      }
      this.popup.setProps({
        getReferenceClientRect: () => event.target.getBoundingClientRect()
      })
    },
    hideLikePicker() {
      this.popup.hide()
      commentsContainer.removeEventListener('scroll', this.hideLikePicker)
    }
  },
  destroyed() {
    this.popup.destroy()
    this.picker.destroy()
  }
}
</script>

<style scoped lang="scss">
.like-link {
  cursor: pointer;
  color: $primary-color;
  display: flex;
  align-items: center;
  * {
    pointer-events: none;
  }
}
</style>
